export default __webpack_public_path__ + "static/media/empty_devises.f784992f.png";